

import gql from 'graphql-tag';

const updateAssetMutation = gql`
  mutation updateAsset($assetId: String!, $input: AssetInput!) {
    updateAsset(assetId: $assetId, input: $input) {
      assetId
    }
  }
`;

const updateAsset = () => ({
  mutation: updateAssetMutation,
  module: 'assets',
  buildVariables: ({ assetId, input


  }) => ({ assetId, input })
});

export default updateAsset;